<ng-container *ngIf="hasFieldOrEditable(field)">
    <button class="button-toggle" type="button" [attr.aria-expanded]="opened">
    <span class="button-toggle" *scRichText="field"></span>
    <img *ngIf="!opened" class="caret-down" src="assets/icons/caret-down-icon.png" alt="" aria-hidden="true">
    <img *ngIf="opened" class="caret-up" src="assets/icons/caret-down-icon.png" alt="" aria-hidden="true">
    </button>
</ng-container>
